<template>
  <div class="floating-buttons" :class="{ show: isVisible }">
    <!-- 公众号二维码 -->
    <div class="floating-btn floating-btn-1 qr-item">
      <img src="../assets/xuanfu2.png" alt="" />
      <div class="qr-popup">
        <img v-if="wxQrUrl" :src="wxQrUrl" alt="公众号二维码" />
        <div v-else class="qr-placeholder">暂无二维码</div>
      </div>
    </div>
    <!-- APP下载二维码 -->
    <div class="floating-btn floating-btn-2 qr-item">
      <img src="../assets/xuanfu1.png" alt="" />
      <div class="qr-popup">
        <img v-if="webDownloadUrl" :src="webDownloadUrl" alt="APP下载二维码" />
        <div v-else class="qr-placeholder">暂无二维码</div>
      </div>
    </div>
    <!-- 返回顶部按钮 -->
    <div class="floating-btn floating-btn-3 back-to-top" @click="scrollToTop">
      <img src="../assets/xuanfu3.png" alt="返回顶部" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BackToTop",
  props: {
    webDownloadUrl: {
      type: String,
      default: "",
    },
    wxQrUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isVisible: false,
      scrollThreshold: 300, // 滚动超过300px时显示按钮
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
    // 初始化检查
    this.handleScroll();
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // Vue 3 兼容
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 检查滚动距离
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isVisible = scrollTop > this.scrollThreshold;
    },
    scrollToTop() {
      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.floating-buttons {
  position: fixed;
  // 在版心外部：当屏幕宽度 > 1248px 时
  // .container: max-width: 76rem (1216px)，居中显示
  // 版心右边缘距离屏幕右边缘 = (100vw - 76rem) / 2
  // 按钮在版心外部 40px，所以按钮距离屏幕右边缘 = (100vw - 76rem) / 2 - 40px
  // 使用 max() 确保按钮不会超出屏幕（最小距离屏幕右边缘 20px）
  right: max(20px, calc((100vw - 76rem) / 2 - 50px));
  bottom: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
  transform: translateY(20px);

  &.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .floating-btn {
    width: 42px;
    height: 42px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }

    &.back-to-top {
      cursor: pointer;
      transition: transform 0.3s ease;

      img {
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.1);
        }
      }

      &:active {
        transform: scale(0.95);
      }
    }

    &.qr-item {
      position: relative;
      cursor: pointer;

      .qr-popup {
        position: absolute;
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 10px;
        background: #fff;
        padding: 10px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s;
        z-index: 100;
        white-space: nowrap;

        img {
          width: 120px;
          height: 120px;
          object-fit: contain;
          display: block;
        }

        .qr-placeholder {
          padding: 20px;
          color: #999;
          font-size: 12px;
          text-align: center;
          width: 120px;
        }

        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 100%;
          transform: translateY(-50%);
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 6px solid #fff;
        }
      }

      &:hover .qr-popup {
        opacity: 1;
        visibility: visible;
      }
    }
  }
}

// 当屏幕宽度 <= 1248px 时，.container 会占满宽度（有 padding），按钮在版心外部
@media (max-width: 1248px) {
  .floating-buttons {
    // 版心右边缘距离屏幕右边缘 = 16px (padding)
    // 按钮在版心外部 40px，所以按钮距离屏幕右边缘 = 16px - 40px = -24px
    // 使用 max() 确保按钮不会超出屏幕（最小距离屏幕右边缘 20px）
    right: max(20px, calc(16px - 40px));
  }
}

// 平板端样式调整
@media (max-width: 1200px) {
  .floating-buttons {
    right: max(15px, calc(16px - 30px));
    bottom: 15px;

    .floating-btn {
      width: 38px;
      height: 38px;
    }
  }
}

// 移动端样式调整
@media (max-width: 768px) {
  .floating-buttons {
    right: max(12px, calc(12px - 20px));
    bottom: 12px;

    .floating-btn {
      width: 36px;
      height: 36px;
    }
  }
}
</style>
